import * as SentryBrowser from '@sentry/browser';
export { default as initSentryBrowser } from './browser';
export { SentryBrowser };